import { useSettingsDialog } from '@core/hooks/useSettingsDialog';
import { Icon, IconSize, Settings, ExternalLink } from '@soteria/design-system-ve';

import * as styles from './GuideFooter.css';

/**
 * GuideFooter component
 * Xbox-inspired sticky footer with settings button and support link
 * Persists across all tabs
 */
export function GuideFooter() {
  const { openDialog } = useSettingsDialog();

  return (
    <footer className={styles.guideFooter}>
      {/* Empty left spacer for layout balance */}
      <div className={styles.leftSpacer} />

      {/* Centered support link */}
      <div className={styles.footerCenter}>
        <ExternalLink
          href="https://gpso-catalog-frontend-prod.yellowground-7c956e31.eastus2.azurecontainerapps.io/#/playbook/soteria-support"
          iconSize={IconSize.XSmall}
          variant="accent"
        >
          Need help? Visit Soteria Support
        </ExternalLink>
      </div>

      {/* Settings button on the right */}
      <button aria-label="Open settings" className={styles.settingsButton} type="button" onClick={openDialog}>
        <Icon icon={Settings} iconSize={IconSize.Small} />
      </button>
    </footer>
  );
}
